module.exports = __webpack_public_path__ + "static/media/header_title.e0f2cc34.png";